// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-objective {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
}

.fund-objective__subheader {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-line);
  background-color: var(--surface-primary);
}

.fund-objective__label {
  flex: 1 0 0;
  min-width: 0;
  padding: 4px 0;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
}

.fund-objective__content {
  margin: 0;
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  word-break: break-word;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/FundObjective/FundObjective.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;AAC5B","sourcesContent":[".fund-objective {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.fund-objective__subheader {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border-line);\n  background-color: var(--surface-primary);\n}\n\n.fund-objective__label {\n  flex: 1 0 0;\n  min-width: 0;\n  padding: 4px 0;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n}\n\n.fund-objective__content {\n  margin: 0;\n  width: 100%;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  word-break: break-word;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
